import queries from '@apis/queries';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { useQuery } from '@tanstack/react-query';

function useDiscounts() {
  const { shopId, totalAmount, orderLines } = useCalculatedRequest();
  const { data } = useQuery({
    ...queries.discounts.list(shopId),
    enabled: !!shopId,
  });
  // 쿠폰 사용 가능 여부
  const couponUsable = orderLines.some((line) => line.couponUsable);
  const coupons = couponUsable ? data?.coupons
  // 최소 주문 금액 필터
    ?.filter((coupon) => {
      const { minOrderAmount } = coupon;
      return !(minOrderAmount !== undefined && minOrderAmount > totalAmount);
    }) : [];

  return {
    coupons,
    points: data?.points,
    gifts: data?.gifts,
  };
}

export default useDiscounts;
